/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaleFileReference
 */
export interface StaleFileReference {
    /**
     * 
     * @type {string}
     * @memberof StaleFileReference
     */
    fieldId?: string;
    /**
     * 
     * @type {string}
     * @memberof StaleFileReference
     */
    fieldName?: string;
    /**
     * FILE_FIELD / IMAGE_FIELD / MULTI_FILE_FIELD / IMAGE_SERIES_FIELD
     * @type {string}
     * @memberof StaleFileReference
     */
    fieldType?: string;
    /**
     * Der File-Slug, dessen physische Datei im Storage fehlt.
     * @type {string}
     * @memberof StaleFileReference
     */
    resourceIdentifier?: string;
    /**
     * Die UUID des FileMetaData-Eintrags innerhalb des Feldwerts. Nützlich, um den Eintrag bei Listen-Werten zu identifizieren.
     * @type {string}
     * @memberof StaleFileReference
     */
    fileMetaId?: string;
}

/**
 * Check if a given object implements the StaleFileReference interface.
 */
export function instanceOfStaleFileReference(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StaleFileReferenceFromJSON(json: any): StaleFileReference {
    return StaleFileReferenceFromJSONTyped(json, false);
}

export function StaleFileReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaleFileReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName'],
        'fieldType': !exists(json, 'fieldType') ? undefined : json['fieldType'],
        'resourceIdentifier': !exists(json, 'resourceIdentifier') ? undefined : json['resourceIdentifier'],
        'fileMetaId': !exists(json, 'fileMetaId') ? undefined : json['fileMetaId'],
    };
}

export function StaleFileReferenceToJSON(value?: StaleFileReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldId': value.fieldId,
        'fieldName': value.fieldName,
        'fieldType': value.fieldType,
        'resourceIdentifier': value.resourceIdentifier,
        'fileMetaId': value.fileMetaId,
    };
}

